export const COMIC_LANGUAGES = {
  Serbian: 'Serbian',
  Slovenian: 'Slovenian',
  English: 'English',
  Spanish: 'Spanish',
  French: 'French',
  Russian: 'Russian',
  Italian: 'Italian',
  Chinese: 'Chinese',
  Turkish: 'Turkish',
  Hungarian: 'Hungarian',
  Portuguese: 'Portuguese',
};
